import { render } from "./StickyElement.vue?vue&type=template&id=58ebe1fa"
import script from "./StickyElement.vue?vue&type=script&lang=js"
export * from "./StickyElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__